<div
  class="bg-transparent"
  [class.divide-y]="divide()"
  [class.space-y-3]="spaceY()"
>
  <ng-content></ng-content>
</div>
